import { CommentInterface, ReplyCommentInterface, TicketCommentInterface } from '@/services/QA/comment/interfaces';
import { TicketNoteInterface } from '@/services/QA/note/interfaces';
import { ChatScoreRequestInterface, ScoreInterface } from '@/services/QA/chat/interfaces';
import { TagInterface } from '@/services/QA/tag/interfaces';

export interface AttachmentInterface {
  id: number;
  encUrl: string;
  filename: string;
  type: string;
}

export interface ReplyAttachmentInterface {
  attachmentId: number;
  attachment: AttachmentInterface;
  reply: TicketReplyInterface;
  replyId: number;
}


export interface TicketReplyInterface {
  id: number;
  name: string;
  email: string;
  date: string;
  body: string;
  status: string;
  type: string;
  attachments: AttachmentInterface[];
  comments: ReplyCommentInterface[];
  commentInputVisible: boolean;
}

export interface TicketScoreInterface {
  ticketId: number,
  score: ScoreInterface,
}

export interface TicketAgentsInterface {
  id: string,
  name: string,
  fullName?: string
  email: string,
}

export interface TicketInterface {
  id: number;
  date: string;
  ticketNumber: string;
  clientId: string;
  name: string;
  email: string;
  status: string;
  subject: string;
  body: string;
  priority: string;
  type: string;
  departmentName: string;
  closedDate: string;
  replies: TicketReplyInterface[];
  agents: TicketAgentsInterface[];
  comments: TicketCommentInterface[]
  notes: TicketNoteInterface[]
  reviewerId: string,
  reviewedOn: number,
  scores: TicketScoreInterface[],
  tags: TagInterface[]

  [key: string]: string | number | TicketScoreInterface[] | TagInterface[]
    | TicketCommentInterface[] | TicketReplyInterface[] | TicketAgentsInterface[] | TicketNoteInterface[]
}

export interface TicketsSearchResultInterface {
  tickets: TicketInterface[],
  totalItems: number,
}

export interface TicketsWSMessageInterface {
  tickets: TicketInterface[];
}

export interface TicketWSMessageInterface {
  ticket: TicketInterface;
}

export interface TicketScoreRequestInterface {
  [scoreTypeId: number]: number;
}

export enum TicketPriorities {
  LOW,
  NORMAL,
  HIGH,
  CRITICAL,
}


export default interface TicketRepositoryInterface {
  getAllTickets(page: number, reviewed: boolean): Promise<[TicketInterface[], number]>;

  getUnreviewedTicket(ticketId: number): Promise<TicketInterface>;

  searchTickets(search: string, page: number): Promise<void>;

  reviewTicket(
    ticketId: number,
    agents: string[],
    scores: TicketScoreRequestInterface,
    tags: number[],
    sendStats?: boolean,
  ): Promise<void>;

  getOneById(ticketId: number): Promise<TicketInterface>;
}
